import React from "react";
import clsx from "clsx";
import {
  useCopyToClipboard,
  useSelectedTheme,
  useTranslate,
} from "../../../Hooks";
import PropTypes from "prop-types";

// Icons
import { CopyIcon } from "../../../assets/icons";

// styles
import useStyles from "./styles";

function CustomCopyToClipboard(props) {
  const {
    childrenData,
    data,
    copyDoneShowTime,
    children,
    customContainerClasses,
    fontSize,
    customText,
  } = props;

  const { copied, copyToClipboardHandler } =
    useCopyToClipboard(copyDoneShowTime);

  const {
    theme: { palette },
  } = useSelectedTheme();

  const { translate } = useTranslate("SharedV2");

  const styles = useStyles({ fontSize });

  const handleCopy = (e) => {
    e.stopPropagation();
    e.preventDefault();
    copyToClipboardHandler(data);
  };

  return (
    <div
      className={clsx(styles.copyToClipBoardContainer, {
        [customContainerClasses]: !!customContainerClasses,
      })}
      onClick={handleCopy}
    >
      {!!childrenData && <span>{childrenData}</span>}
      {children || (
        <CopyIcon
          width="20"
          height="20"
          fill={palette.button.tertiary_fg}
          style={{ marginInlineStart: "8px" }}
        />
      )}

      <div
        className={clsx(styles.tooltip, { [styles.tooltipVisible]: copied })}
      >
        {customText || translate("id-copied")}
      </div>
    </div>
  );
}

CustomCopyToClipboard.propTypes = {
  copyDoneShowTime: PropTypes.number,
  childrenData: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  data: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  fontSize: PropTypes.string,
};

CustomCopyToClipboard.defaultProps = {
  copyDoneShowTime: 1000,
  childrenData: undefined,
  data: undefined,
  children: null,
  fontSize: "16px",
};

export default CustomCopyToClipboard;
